import Typography from '../Typography';

interface Props {
  tags: any[];
  fontFamily: string;
  bgColor: string;
  color: string;
}

const Tags = ({ tags, fontFamily, bgColor, color }: Props) => {
  if (!tags || tags?.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => {
        return (
          <div
            key={tag.id}
            style={{
              backgroundColor: bgColor,
            }}
            className="flex w-fit items-center space-x-1 rounded px-2 pb-0.5"
          >
            <Typography as="span" size={'xs'} fontFamily={fontFamily} className="text-xs font-medium" color={color}>
              <span className="text-xs">{tag.display}</span>
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default Tags;
